// extracted by css-extract-rspack-plugin
export default {"pageLayout":"k53DiTO5wVow8Op1__pageLayout___"};